import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/digital-product-store/DigitalProductStoreClient.tsx");
